<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国家文物局文物古迹司）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入单位名称/法定代表人"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div style="margin-top: 5px; padding: 0 20px">
          <div style="padding: 20px; border: 1px solid #e6ebf5">
            <el-row>
              <el-col style="font-size: 14px" :span="2">资格类型:</el-col>
              <el-col :span="10">
                <el-checkbox-group
                  class="col"
                  v-model="qualifications"
                  @change="qualificationsChange()"
                >
                  <el-checkbox
                    v-for="(item, index) in qualificationsList"
                    :key="index"
                    :label="item.code"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row style="padding: 0 20pxa">
              <el-col style="font-size: 14px" :span="2">业务范围：</el-col>
              <el-col :span="10">
                <el-checkbox-group
                  class="col"
                  v-model="range"
                  @change="rangeChange()"
                >
                  <el-checkbox
                    v-for="(item, index) in rangeList"
                    :key="index"
                    :label="item.code"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="dat">
          <div class="paging"></div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              style="margin: 10px"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            v-loading="loading"
            :span-method="objectSpanMethod"
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="55"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="personName"
              label="姓名"
              min-width="85px"
            >
              <template slot-scope="scope">
                         
                <span
                  @click="nameFF(scope.row)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 16px;
                    cursor: pointer;
                  "
                  >{{ scope.row.personName }}</span
                >                   
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="organizationName"
              label="所在单位"
              min-width="220px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="typeName"
              label="资格类型"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="rangeName"
              label="业务范围"
              min-width="330px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="gmtModified"
              label="数据更新时间"
              min-width="160px"
            >
              <template slot-scope="scope">
                <p style="font-size: 16px">
                  {{
                    scope.row.gmtModified
                      ? scope.row.gmtModified.slice(
                          0,
                          scope.row.gmtModified.indexOf(" ")
                        )
                      : "暂无更新时间"
                  }}
                </p>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
    <el-dialog
      width="900px"
      :title="detailsList.organizationName"
      :before-close="handleClose"
      :visible.sync="dialogTableVisible"
    >
      <div class="hxl_titlee"></div>
      <el-scrollbar class="scrollbar" style="height: 400px">
        <div>
          <h4>单位基本信息</h4>
          <table class="mailTable">
            <tr>
              <td class="column">单位名称：</td>
              <td class="row" colspan="2">
                {{ detailsList.organizationName }}
              </td>
              <td class="column">统一社会信用代码：</td>
              <td class="row" colspan="2"></td>
            </tr>
            <tr>
              <td class="column">所属地区：</td>
              <td class="row">{{ detailsList.districtCode }}</td>
              <td class="column">法定代表人：</td>
              <td class="row">{{ detailsList.legalRepresentative }}</td>
              <td class="column">注册资金(万元)：</td>
              <td class="row">{{ detailsList.registeredCapital }}</td>
            </tr>
            <tr>
              <td class="column">经济性质：</td>
              <td class="row">{{ detailsList.organizationNature }}</td>
              <td class="column">联系电话：</td>
              <td class="row">{{ detailsList.telNo }}</td>
              <td class="column">电子邮箱：</td>
              <td class="row">{{ detailsList.email }}</td>
            </tr>
            <tr>
              <td class="column">地址：</td>
              <td class="row" colspan="5">{{ detailsList.address }}</td>
            </tr>
          </table>
          <h4>单位资质信息</h4>
          <el-table
            :data="detailsList.typeList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="type"
              label="资质类型"
              min-width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="468px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="certificateNum"
              label="资质公布文件"
              min-width="150px"
            >
            </el-table-column>
          </el-table>
          <h4>资格人员列表</h4>
          <el-table
            :span-method="objectSpanMethods"
            :data="peoList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="personName"
              label="姓名"
              min-width="150px"
            >
              <template slot-scope="scope">
                <span
                  @click="nameFF(scope.row)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  >{{ scope.row.personName }}</span
                >                   
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="pcrpersonQualicationTypeName"
              label="资格类型"
              min-width="150px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="range"
              label="业务范围"
              min-width="460px"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </el-dialog>
    <el-dialog
      width="900px"
      :title="personnelNameList.personName"
      :visible.sync="innerVisible"
    >
      <div class="hxl_titlee"></div>
      <el-scrollbar class="scrollbar" style="height: 400px">
        <div>
          <h4>人员基本信息</h4>
          <table class="mailTable">
            <tr>
              <td class="column">人员姓名：</td>
              <td class="row" colspan="2">
                {{ personnelNameList.personName }}
              </td>
              <td class="column">所在单位：</td>
              <td class="row" colspan="4">
                <span
                  @click="companyFF(legalForms)"
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  >{{ personnelNameList.organizationName }}</span
                >
              </td>
            </tr>
          </table>
          <h4>人员资格信息</h4>
          <el-table
            :data="personnelNameList"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="zglx"
              label="资格类型"
              min-width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="ywfwListStr"
              label="业务范围"
              min-width="468px"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.ywfwListStr != "null" ? scope.row.ywfwListStr : ""
                }}</span
                >                   
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="certNo"
              label="证书编号"
              min-width="150px"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </el-dialog>
  </el-row>
</template>
<script>
import {
  URL_COMPREHENSIVE_EXCUSE,
  URL_PRCPERSOM_FIND,
  URL_ONTHELINE_CLICK,
  URL_COMPANY_ID,
  URL_PRCUNITID_BY_PRC,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import Vue from "vue";
import { objectSpan } from "../../../utils/mergecell";
import { frontHeater } from "../../../utils/md5encryption";
import { timingSafeEqual } from "crypto";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "全国文物保护工程资格人员数据库",
        // 浏览次数
        num: "2",
      },
      // 资质类型
      qualificationsList: [],
      qualifications: [],
      // 业务范围
      rangeList: [],
      range: [],
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 两个隐藏的显示
      dialogTableVisible: false,
      innerVisible: false,
      // 点击姓名显示的模块的数据↓↓↓↓↓
      // 获取对应行的id
      personName: null,
      personnelNameID: null,
      // 获取根据行获取的数据详情
      personnelNameList: [],
      // 获取点击行的所在单位
      personnelNameOrgan: null,
      // 获取所在单位id
      personnelNameOrganID: null,
      // 点击单位显示的模块的数据↓↓↓↓↓
      // 根据单位获取的详情
      detailsList: [],
      // 根据单位获取人员
      peoList: [],
      // 前往页数
      currentPage: 1,
      // 条数
      pagesize: 20,
      total: 0,
      // 所有要合并的数量（一行一行的开始）
      spanArr: [],
      gmtDate: "",
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.getQualificationsList();
    this.getrangeList();
    this.getNumberViews();
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2) {
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      }
    },
    objectSpanMethods({ rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row_1 = this.provinceArrs[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      }
    },
    merages() {
      this.merageInits();
      for (let i = 0; i < this.peoList.length; i++) {
        if (i === 0) {
          //第一行必须存在
          this.provinceArrs.push(1);
          this.provincePoss = 0;
        } else {
          if (this.peoList[i].personName === this.peoList[i - 1].personName) {
            this.provinceArrs[this.provincePoss] += 1;
            this.provinceArrs.push(0);
          } else {
            this.provinceArrs.push(1);
            this.provincePoss = i;
          }
        }
      }
    },
    merageInits() {
      this.provinceArrs = [];
      this.provincePoss = 0;
    },

    merage() {
      this.merageInit();
      for (let i = 0; i < this.legalForms.length; i++) {
        if (i === 0) {
          //第一行必须存在
          this.provinceArr.push(1);
          this.provincePos = 0;
        } else {
          if (this.legalForms[i].id === this.legalForms[i - 1].id) {
            this.provinceArr[this.provincePos] += 1;
            this.provinceArr.push(0);
          } else {
            this.provinceArr.push(1);
            this.provincePos = i;
          }
        }
      }
    },
    merageInit() {
      this.provinceArr = [];
      this.provincePos = 0;
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataPrcpersonTypeRelevance"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataPrcpersonTypeRelevance",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] =
        "DataPrcpersonTypeRelevance";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 请求数据
    getList() {
      this.loading = true;
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        keyWord: this.searchOn,
        qualification: this.qualifications, // 资格类型
        range: this.range, // 业务范围
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["qualification"] = this.qualifications;
      this.$http.defaults.headers.common["range"] = this.range;
      this.$http.post(Url + URL_PRCPERSOM_FIND, params).then((res) => {
        if (res.status == 200) {
          this.legalForms = [];

          // this.legalForms = res.data.data.list;
          let list = res.data.data.list;
          this.total = res.data.data.total;
          list.forEach((item) => {

            let obj = {
              organizationId: item.ssdwid,
              personName: item.xm,
              organizationName: item.ssdw,
              gmtModified: item.updateTime,
              id: item.id,
              typeName: item.zglx,
              rangeName: item.ywfwListStr,
            };
            this.legalForms.push(obj);
            this.merage();
          });
          this.loading = false;
        }
      });
    },
    // 获取资质类型列表
    getQualificationsList() {
      let result = frontHeater(["ClassCode"], ["PcrpersonQualicationTypeCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "PcrpersonQualicationTypeCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "PcrpersonQualicationTypeCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.qualificationsList = res.data.data;
        }
      });
    },
    handleClose() {
      this.dialogTableVisible = false;
    },
    // 获取业务范围列表
    getrangeList() {
      let result = frontHeater(["ClassCode"], ["PcrunitQualicationRangeCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "PcrunitQualicationRangeCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] =
        "PcrunitQualicationRangeCode";

      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.rangeList = res.data.data;
        }
      });
    },
    // 获取点击行的详细信息
    getPeopleDetail() {
      let Url = util.getAjaxUrl("axiosTWo");
      let result = frontHeater(["pcrpersonId"], [this.personnelNameID]);
      let params = {
        pcrpersonId: this.personnelNameID,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["pcrpersonId"] = this.personnelNameID;
      this.$http.post(Url + URL_ONTHELINE_CLICK, params).then((res) => {
        if (res.status == 200) {
          Vue.set(res.data.data, "organizationName", this.personnelNameOrgan);
          Vue.set(res.data.data, "personName", this.personName);


          Vue.set(res.data.data, "organizationId", this.personnelNameOrganID);
          let datas = res.data.data;

          this.personnelNameList = datas;
        }
      });
    },
    // 获取点击单位的详细信息
    getListQualifiedPersonnel(id) {
      let result = frontHeater(["pcrunitId"], [id]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pcrunitId: id,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["pcrunitId"] = id;
      this.$http.post(Url + "/api/prcunit/two", params).then((res) => {
        if (res.data.code == 200) {
          this.detailsList = res.data.data;
        } else {
          this.detailsList = {};
        }
      });
    },
    // 获取点击单位的详细信息里边的人员信息
    getPersonnelList(id) {
      let result = frontHeater(["organizationId"], [id]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNation: { pageNumber: 1, pageSize: 999 },
        organizationId: id,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["organizationId"] = id;
      this.$http.post(Url + URL_PRCUNITID_BY_PRC, params).then((res) => {
        if (res.status == 200) {
          let list = res.data.data;
          list.forEach((item) => {
            if (item.pcrpersonQualicationTypeName === "责任监理师") {
              this.$set(item, "range", "");
            }
            // this.peoList = list;
            this.peoList.push(item);
          });
          this.merages();
        }
      });
    },
    // 点击姓名的执行的方法
    nameFF(val) {
      console.log(val, "val");
      if (val.id) {
        this.personnelNameID = val.id;
      } else {
        this.personnelNameID = val.personId;
      }
      this.personnelNameOrgan = val.organizationName;
      this.personnelNameOrganID = val.organizationId;
      this.personName=val.personName;
      this.innerVisible = true;
      this.getPeopleDetail();
      setTimeout(() => {
        this.dialogTableVisible = false;
      }, 50);
    },
    // 点击单位的执行的方法
    companyFF(val) {
      this.detailsList = [];
      this.peoList = [];
      if (this.personnelNameOrganID) {
        this.dialogTableVisible = true;
        setTimeout(() => {
          this.innerVisible = false;
        }, 50);
        this.getListQualifiedPersonnel(this.personnelNameOrganID);
        this.getPersonnelList(this.personnelNameOrganID);
      } else {
        this.dialogTableVisible = true;
        setTimeout(() => {
          this.innerVisible = false;
        }, 50);
      }
    },
    //修改日期格式
    runGmtModified(data) {
      let mydate = dateStr.slice(0, data.indexOf("."));
      console.log(mydate);
      // this.gmtDate = mydate;
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.range = [];
      this.qualifications = [];
      this.currentPage = 1;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 解决换页后index从1开始
    // count(index) {
    //   return (this.currentPage - 1) * this.pagesize + index + 1;
    // },
    // 资质改变
    qualificationsChange() {
      this.getList();
    },
    // 范围改变
    rangeChange() {
      this.getList();
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";

.el-col-10 {
  width: 90%;
  .col {
    display: flex;
    flex-wrap: wrap;
    /deep/.el-checkbox__label {
      width: 180px;
    }
  }
}

/deep/.el-dialog__header {
  font-size: 14px;
  color: rgb(68, 68, 68);
  text-align: center;
}

.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.hxl_titlee {
  border-bottom: 3px solid #b71c1c;
}
/deep/.el-dialog__header {
  padding: 20px 0 0;
  font-size: 14px !important;
  color: rgb(68, 68, 68);
}
/deep/.el-dialog__body {
  padding: 10px;
  font-size: 14px !important;
  color: rgb(68, 68, 68);
}
.sele {
  width: 170px;
  height: 32px;
  margin: 10px 0;
}
.dat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  // margin-bottom: 10px;
}
/deep/.el-input--suffix .el-input__inner {
  height: 32px;
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 30px;
  }
}
h4 {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
　　.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #606266;
}
　　.mailTable {
  font-size: 14px;
  color: #606266;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}
　　.mailTable tr td {
  border: 1px solid #606266;
  height: 40px;
  box-sizing: border-box;
  line-height: 20px;
  padding: 10px;
}
　.column {
  text-align: center;
  background-color: #ebe6db;
  color: #393c3e;
  width: 150px;
}
.row {
  color: #393c3e;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b71c1c;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #b71c1c;
  border-color: #b71c1c;
}
/deep/ .el-loading-spinner .path {
  stroke: red;
}
</style>